export enum DatabaseChatType {
  Angle = "Angle",
  ClientSupport = "ClientSupport",
  ExpertSupport = "ExpertSupport",
  Workspace = "Workspace"
}

export enum ChatUserAPIRole {
  Expert = "Expert",
  Admin = "ArbolusAdmin",
  Client = "Client"
}

// Used as translation keys
export enum ChatUserRole {
  Expert = "expertChatRole",
  Admin = "adminChatRole",
  Client = "clientChatRole"
}

export enum MessageType {
  Incoming,
  Outgoing
}

export enum ExpertAvailabilityActions {
  ArrangeCall = "ArrangeCall",
  RequestTimeSlots = "RequestTimeSlots"
}

export enum DiscoverFilterOperator {
  Include = "include",
  Exclude = "exclude"
}

export enum DiscoverFilterType {
  Expert_Locations = "expertLocations",
  Work_History_Locations = "workHistoryLocations",
  Company = "company",
  Keywords = "keywords",
  Projects = "projects",
  Customers = "customers",
  Industries = "industries"
}

export enum FilterTimeSelectorOptions {
  All = "all",
  Current = "current",
  PastNotCurrent = "pastNotCurrent"
}

export enum FindExpertStatusEnum {
  OK = "Ok",
  RESULTS_NOT_FOUND = "ResultsNotFound",
  EXPERT_RECOMMENDATIONS_NOT_GENERATED = "ExpertRecommendationsNotGenerated"
}

export enum KEYWORDS_SEARCH_OPTIONS {
  USER_TITLE = "user.title",
  WORK_HISTORIES_TITLE = "workHistories.title",
  WORK_HISTORIES_COMPANY = "workHistories.companyName",
  PROJECTS_NOTES = "projects.notes",
  PROJECTS_ANSWERS = "projects.answers"
}

export enum FILTERS_SEARCH_MATCHES {
  FILTER_SEARCH_TERM = "filter.searchTerm",
  FILTER_PROJECTS = "filter.projects",
  FILTER_COMPANIES = "filter.companies",
  FILTER_WORK_HISTORY_LOCATIONS = "filter.workHistoryLocations",
  FILTER_EXPERT_CURRENT_LOCATIONS = "filter.expertCurrentLocations",
  FILTER_USER_TITLE = "filter.keywords.user.title",
  FILTER_WORK_HISTORIES_TITLE = "filter.keywords.workHistories.title",
  FILTER_WORK_HISTORIES_COMPANY = "filter.keywords.workHistories.companyName",
  FILTER_PROJECTS_NOTES = "filter.keywords.projects.notes",
  FILTER_PROJECTS_ANSWERS = "filter.keywords.projects.answers",
  FILTER_CUSTOMERS = "filter.customers",
  FILTER_INDUSTRIES = "filter.industries"
}

export enum EVENT_FORM {
  TITLE = "title",
  STARTING_DATE = "startingDate",
  ENDING_DATE = "endingDate",
  STARTING_TIME = "startingTime",
  ENDING_TIME = "endingTime",
  TIMEZONE = "timezone",
  GUESTS = "guests",
  NOTES = "notes",
  FREE_TRANSCRIPT = "freeTranscript",
  SMART_TRANSCRIPT = "smartTranscript",
  ATTACHMENTS = "attachments"
}

export enum NPS {
  Promoters = "Promoters",
  Passives = "Passives",
  Detractors = "Detractors"
}

export enum RENEWAL_INTENT {
  Yes = "Yes",
  No = "No",
  Unsure = "NotSure"
}

export enum MANAGE_ANGLES {
  ANGLES_LIST = "anglesList",
  CREATE_ANGLE = "createAngle",
  EDIT_ANGLE = "editAngle"
}

export enum ANGLE_FORM {
  TITLE = "title",
  REQUIRED_EXPERTS = "requiredExperts",
  TEAM_MEMBERS = "teamMembers",
  OWNER = "owner",
  COLOR = "color",
  SPECIFICATIONS = "specifications",
  QUALIFICATION_QUESTION = "qualificationQuestion",
  ENABLE_QUALIFICATION_QUESTION = "enableQualificationQuestion",
  ENABLE_SCREENING_QUESTIONS = "enableScreeningQuestions",
  ENABLE_CUSTOMER_INSIGHTS = "enableCustomerInsights",
  TARGET_COMPANIES = "targetCompanies",
  SCREENING_QUESTIONS = "screeningQuestions"
}

export enum EDIT_ANGLE_TABS {
  DETAILS = "details",
  SCREENING_QUESTIONS = "screeningQuestions"
}

export enum ANGLE_ORDER_BY {
  CREATED = "Created"
}

export enum SCREENING_QUESTION_TYPE {
  SHORT_TEXT = "ShortText",
  MULTI_CHOICE = "MultiChoice",
  VALUE = "Value"
}

export enum SCREENING_QUESTION_VALUE_TYPE {
  NUMBER = "Number",
  MULTI_RATING = "MultiRating"
}

export enum REFERRAL_STATUS {
  Approved = "Approved",
  Accept = "Accept",
  Candidate = "Candidate"
}

export enum EXPERT_SUMMARY_DATE_RANGE {
  Last24hrs = "Last24hrs",
  Last48hrs = "Last48hrs",
  All = "All"
}

export enum DATE_RANGE_OPTION {
  Last24Hrs = "last24hrs",
  Last48Hrs = "last48hrs",
  All = "all"
}

export enum API_FILTER_PARAM {
  AngleIds = "filters.AngleIds",
  DateRange = "filters.DateRange",
  IncludeApproved = "filters.IncludeApproved"
}

export enum API_SECTION_PARAM {
  Tagline = "includeSections.Tagline",
  Biography = "includeSections.Biography",
  Availability = "includeSections.Availability",
  CreditPrice = "includeSections.CreditPrice",
  ScreeningQuestions = "includeSections.ScreeningQuestions",
  Geography = "includeSections.Geography",
  WorkHistory = "includeSections.WorkHistory",
  CustomerOf = "includeSections.CustomerOf"
}

export enum SECTION_KEY {
  Tagline = "tagline",
  Biography = "biography",
  Availability = "availability",
  CreditPrice = "creditPrice",
  ScreeningQuestions = "screeningQuestions",
  Geography = "geography",
  WorkHistory = "workHistory",
  CustomerOf = "customerOf"
}

export enum TRANSLATION_KEY {
  FiltersDateRangeLast24hrs = "filters.dateRange.last24hrs",
  FiltersDateRangeLast48hrs = "filters.dateRange.last48hrs",
  FiltersDateRangeAll = "filters.dateRange.all"
}

export enum REFERRAL_REJECT_REASON {
  ALREADY_ENGAGED = "AlreadyEngaged",
  WRONG_GEOGRAPHY = "WrongGeography",
  COMPANY_COVERED = "CompanyCovered",
  NOT_SENIOR = "NotSenior",
  ANGLE_COMPLETED = "AngleCompleted",
  OTHER = "Other"
}

export enum AvailabilityStatus {
  BOOK = "book",
  CANDIDATE = "candidate",
  PENDING_COMPLIANCE = "pendingCompliance"
}

export enum EmailTemplateType {
  ProjectApplication = "ProjectApplication",
  ProjectApplicationFollowUp = "ProjectApplicationFollowUp",
  CanopyApplication = "CanopyApplication",
  CanopyApplicationFollowUp = "CanopyApplicationFollowUp",
  Survey = "Survey",
  SurveyFollowUp = "SurveyFollowUp"
}

export enum EMAIL_TEMPLATE_FORM {
  Name = "name",
  Subject = "subject",
  Content = "content",
  Type = "type"
}

export enum CUSTOM_EMAIL_DRAWER_PANEL {
  Canopy = "canopy",
  Survey = "survey",
  Application = "application",
  FollowUp1 = "followUp1",
  FollowUp2 = "followUp2",
  FollowUp3 = "followUp3",
  FollowUp4 = "followUp4"
}
